<template>
  <client-only>
    <div class="resultsLoader" :style="{'top':top+'px' , 'left':left+'px' , 'right':right+'px'}">
      <img src="../../static/ajax-loader.gif" alt="טעינה" v-if="!bgGray" />
      <img src="../../static/ajax-loader-gray.gif" alt="טעינה" v-if="bgGray" />
    </div>
  </client-only>
</template>

<script>
export default {
  props:{
    bgGray:{
      type:Boolean,
       default:false,
       required:false

    },
    top:{
      default:20,
      type:Number,
      required:false
    },
    left:{
      default:20,
      type:Number,
          required:false
    },
    right:{
      default:0,
      type:Number,
      required:false
    }
  }
}
</script>

<style lang="scss" scoped>
.resultsLoader {
  position: absolute;
  right: 0;
  left: 0;
  margin: 0 auto;
  top: 10px;
  z-index: 5;
  display: inline-flex;
  justify-content: center;
}
.resultsLoader img {
  width: 16px;
}

/* results loading */
</style>







